module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-2@3x-bbc39bc5fd3cda7a2b85b3641eb964dc.png";